/**
 * Created by JIocb on 25-Oct-16.
 */
module Factive.Core {
    "use strict"

    export class StorageManagerConstants {
        public static MUTE_SOUNDS = "MUTE_SOUNDS";
        public static USER_PROGRESS = "USER_PROGRESS";
    }
}



// WEBPACK FOOTER //
// src/typescript/Core/Storage/StorageManagerConstants.ts